//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    inner: {
      type: Boolean,
      default: true
    },
    modal: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      onFooter: false,
      scrolled: false,
      scrolledDown: false,
      dark: false,
      observer: null,
      darkObserver: null,
    }
  },
  mounted() {
    this.createObserver()
    window.addEventListener('scroll', this.handleScroll)
    this.handleScroll ()
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll, false);
    this.deleteObserver()
  },
  methods: {
    handleScroll () {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop
      this.scrolledDown = currentScroll > this.lastScroll
      this.lastScroll = currentScroll
      this.scrolled = currentScroll > 50
    },
    deleteObserver() {
      if(this.observer) {
        this.observer.unobserve(document.querySelector('footer'))
      }
      document.querySelectorAll('.dark-trigger').forEach(elem => {
        if(this.darkObserver) {
          this.darkObserver.unobserve(elem);
        }
      })
    },
    createObserver() {
      const profileAside = document.querySelector('.left-aside-top-inner')
      if (profileAside) {
        setTimeout(() => {
          const profileAsideHeight = profileAside.offsetHeight + 50
          const margin = (window.innerHeight - profileAsideHeight) * -1 + 'px'
          const options = {
            root: null,
            rootMargin: `1px 0px ${margin} 0px`,
            threshold: 0
          }

          this.darkObserver = new IntersectionObserver((entries, observer) => {
            for (let i = 0; i < entries.length; i++) {
              if (entries[i].isIntersecting) {
                this.dark = true
                return
              }
            }
            this.dark = false
          }, options)

          document.querySelectorAll('.dark-trigger').forEach(elem => {
            this.darkObserver.observe(elem)
          })
        }, 500)
      }
      const options = {
        rootMargin: "0px"
      }
      this.observer = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          this.onFooter = entry.isIntersecting
        })
      }, options)

      this.observer.observe(document.querySelector('footer'))
    }
  },
}
